const InsightType = Object.freeze({
  LIKES: 'Likes',
  DISLIKES: 'Dislikes',
  POSITIVE_EMOTIONS: 'PositiveEmotions',
  NEGATIVE_EMOTIONS: 'NegativeEmotions',
  POSITIVE_BEHAVIORS: 'PositiveBehaviors',
  NEGATIVE_BEHAVIORS: 'NegativeBehaviors',
  POSITIVE_EMOTIONS_OR_BEHAVIORS: 'PositiveEmotionsOrBehaviors',
  NEGATIVE_EMOTIONS_OR_BEHAVIORS: 'NegativeEmotionsOrBehaviors'
})
export default InsightType
export type InsightTypeStrings = typeof InsightType[keyof typeof InsightType]
// RESERVE BELOW
